import _ from 'lodash';

export function formatName( person ) {
  if ( person.displayName ) return person.displayName;
  if ( person.name ) return person.name;
  if ( person.firstName || person.lastName ) {
    return _.compact( [ person.firstName, person.lastName ] ).join( ' ' );
  }
  if ( person.id ) return `${person.id} (Unable to find name)`;
  return JSON.stringify( person );
}
